module.exports = __webpack_public_path__ + "static/media/selfie_anteojos.72e5eb61.svg";